import React__default from 'react';

const width = 12;
const height = 14;
const IconArrowUp = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M6.99976 13.9995L6.99976 3.82886L10.2927 7.12182L11.7068 5.70776L5.99976 0.000732422L0.293213 5.70776L1.70728 7.12182L4.99976 3.82898L4.99976 13.9995H6.99976Z", fill: fill })));
};

export { IconArrowUp as default };
//# sourceMappingURL=IconArrowUp.js.map
